import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "") ||
  "http://localhost:5000";

export const getLatLong = async (address) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/google-maps/geocode`, {
      params: { address, language: "en" },
    });
    const results = response.data?.results;
    if (results && results.length > 0) {
      return results[0].geometry.location;
    }
    return { lat: "", lng: "" };
  } catch (error) {
    console.error("Error geocoding address:", error);
    return { lat: "", lng: "" };
  }
};
